import {Component, OnInit} from '@angular/core';
import {MesConfigService} from "../config.service";
import {Observable} from "rxjs";

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styles: []
})
export class ChangelogComponent implements OnInit {
  changelog$: Observable<string> = this.configService.getChangelog();

  constructor(private configService: MesConfigService) {
  }

  ngOnInit(): void {
  }

}
